import { ITaskCompletionResponse } from '@/types';

import axiosInstance from './axiosInstance';

export const getTask = (taskId: string): Promise<ITaskCompletionResponse> =>
  axiosInstance.get(`/tasks/${taskId}`);
